module.exports = __webpack_public_path__ + "img/light.872dbdc9.svg";